<template>
    <div class="font-theme" v-if="isReady" v-resize="onResize">
        <v-row no-gutters class="standard-row font-theme" :class="editButton.history_dashboard? 'budget-dashboard-card1' : 'budget-dashboard-card'">
            <v-col cols="12" sm="12" :md="editButton.history_dashboard? (windowSize.x <= 1050? '8' : '9') : '12'" :lg="editButton.history_dashboard? (windowSize.x <= 1530? '9' : '10') : '12'" class="table-budget-dashboard-card">
                <v-row no-gutters class="standard-row font-theme pt-2 px-8" style="font-weight: 700; font-size: 20px;" align="center">
                    <span class="mr-2">
                        Budgeting {{ budget_type }} (beta)
                    </span>
                    <v-col :cols="windowSize.x > 374 ? 4: 6" sm="3" md="2" lg="2">
                        <v-select class="standard-row font-theme d-flex justify-center budget-dashboard-dropdown-select-year" :menu-props="{ bottom: true, offsetY: true }" hide-details height="30" outlined v-model="year_selected" :prepend-inner-icon="windowSize.x > 428 ? 'mdi-calendar' : ''" append-icon="mdi-chevron-down" :items="year_list" style="border-radius: 10px;max-height: none;" @change="searchGroupBudget">
                        </v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <div v-if="windowSize.x <= 600">
                        <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn"
                                @click="addFileExcelBudgeting">
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                    Import Excel
                            </v-btn>
                        </div>
                </v-row>
                <v-row no-gutters class="standard-row font-theme pt-3 px-8 d-flex justify-space-between">
                    <v-col cols="12" sm="12" md="auto" lg="auto" v-if="windowSize.x > 600"> <!--button for pc -->
                        <template>
                            <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn"
                                @click="addFileExcelBudgeting">
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                    Import Excel
                            </v-btn>

                        </template>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" :lg="windowSize.x < 1300? '6' : '7'" class="mt-lg-n6">
                        <v-row no-gutters class="standard-row font-theme mt-md-4 mt-lg-0" align="center">
                            <v-col cols="12" sm="12" md="4" lg="4" class="pl-lg-7 pr-md-4 pr-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header mt-sm-4 mt-md-0">
                                    Plan
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" color="back" readonly v-model="budgetDashboardData.budget_plan" background-color="#F2F2F2" class="topics-budget-box-value centered-input-dashboard-budget"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_plan }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" lg="4" class="pl-lg-7 mt-4 mt-md-0 px-md-2 px-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header">
                                    Actual
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" color="back" readonly v-model="budgetDashboardData.budget_actual" background-color="#F2F2F2" class="topics-budget-box-value centered-input-dashboard-budget"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_actual }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" lg="4" class="pl-lg-7 mt-4 mt-md-0 pl-md-4 pl-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header">
                                    Total
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" color="back" readonly v-model="budgetDashboardData.budget_total" background-color="#F2F2F2" class="topics-budget-box-value centered-input-dashboard-budget"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_total }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="standard-row font-theme px-8">
                    <v-col cols="" sm="" md="" lg="" class="mt-5 mt-lg-n3">
                        <v-slide-group show-arrows mandatory v-model="budgetType" @change="changeTypeEvent()" color="#414040">
                            <v-slide-item v-slot="{ active, toggle }" value="">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Total
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-slot="{ active, toggle }" value="plan">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Plan
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-slot="{ active, toggle }" value="actual">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Actual
                                </v-btn>
                            </v-slide-item>
                        </v-slide-group>
                    </v-col>
                </v-row>
                <v-form ref="budgetForm" lazy-validation>
                    <v-row no-gutters class="standard-row font-theme px-5 pt-2">
                        <v-simple-table class="mb-3 data-table-dashboard-budget" fixed-header :loading="true">
                            <template v-slot:default>
                                <thead>
                                    <tr style="border-radius: 10px solid #333333;">
                                        <th style="min-width: 445px" class="text-left group-name-dashboard-budget-table-header">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-select hide-details outlined dense height="28" append-icon="mdi-chevron-down" :disabled="editButton.edit_button" v-bind="attrs" v-on="on" :items="budgetDashboardData.group_budget" v-model="selectedGroup" @change="filterDataByGroup(selectedGroup)" item-text="group_name" background-color="#D9D9D9" color="#333333" :menu-props="{ bottom: true, offsetY: true }" return-object class="font-theme budget-dashboard-dropdown-select-group">
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 18px;">{{ data.item.group_name }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 18px;">ไม่พบข้อมูล</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-select>
                                                </template>
                                                <span>{{ selectedGroup.group_name }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th style="min-width: 154px" class="dashboard-budget-table-header pl-11">Jan</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Feb</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Mar</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Apr</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">May</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Jun</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Jul</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Aug</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Sep</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Oct</th>
                                        <th style="min-width: 130px" class="dashboard-budget-table-header">Nov</th>
                                        <th style="min-width: 154px" class="dashboard-budget-table-header pr-11">Dec</th>
                                        <th style="min-width: 130px" class="text-center total-dashboard-budget-table-header">Total</th>
                                    </tr>
                                </thead>
                                <tbody v-if="Object.keys(budgetDashboardData).length? budgetDashboardData.group_budget_body_table.length : false">
                                    <tr v-for="(item, index) in budgetDashboardData.group_budget_body_table" :key="item._id">
                                        <td v-if="!editButton.edit_name" class="text-left group-name-dashboard-table-body" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }" :style="{ 'background-color' : (item.edit_type === 'edit_group_name' || item.budget.some(e => e.edit)) ? '#CFE2B3' : 'white'}">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-btn v-if="editButton.delete_data && item.level < 4" @click="openDeleteGroupModal(item, index)" fab dark color="#FF0000" width="15" height="15" elevation="1" class="mr-2 animate-show-card" :class="{ 'ml-4' : item.level === 1, 'ml-8' : item.level === 2, 'ml-12' : item.level === 3 }">
                                                            <v-icon size="16">
                                                                mdi-minus
                                                            </v-icon>
                                                        </v-btn>
                                                    </span>
                                                </template>
                                                <span class="font-theme">Delete {{ convertTooltipHeader(item.level)  }}</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-btn v-if="editButton.edit_number && item.level < 4" @click="eachEditNumberToggle(item, index), tempIndexEditNumber.push(index)" fab dark :color="item.edit_number_status? '#FF0000' : '#0B68D6'" width="15" height="15" elevation="1" class="mr-2 animate-show-card" :class="{ 'ml-4' : item.level === 1, 'ml-8' : item.level === 2, 'ml-12' : item.level === 3 }">
                                                            <v-icon size="12">
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </span>
                                                </template>
                                                <span class="font-theme">Edit Number</span>
                                            </v-tooltip>
                                            <span v-if="item.level === 0" style="font-weight: 700; font-size: 12px; color: black;">{{ item.group_name }}</span>                          <!-----------    group   ----------->
                                            <span v-else-if="item.level === 1" style="font-weight: 400; font-size: 12px; color: black;">{{ item.group_name }}</span>                     <!----------- sub_group3 ----------->
                                            <span v-else-if="item.level === 2" style="font-weight: 400; font-size: 12px; color: black;" :class="{ 'pl-4' : (!editButton.delete_data && !editButton.edit_number) }">{{ item.group_name }}</span> <!----------- sub_group2 ----------->
                                            <span v-else-if="item.level === 3" style="font-weight: 400; font-size: 12px; color: black;" :class="{ 'pl-8' : (!editButton.delete_data && !editButton.edit_number) }">{{ item.group_name }}</span> <!----------- sub_group3 ----------->
                                            <span v-else-if="item.level === 4" style="font-weight: 400; font-size: 12px; color: black;" :class="editButton.delete_data? (budget_type?.toLowerCase() === 'sga'? 'pl-14' : 'pl-10') : 'pl-4'">{{ item.group_name }}</span> <!---------- plan & actual --------->
                                        </td>
                                        <td v-else class="text-left group-name-dashboard-table-body" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row no-gutters class="standard-row font-theme" align="center">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <span v-bind="attrs" v-on="on">
                                                            <v-btn v-if="editButton.delete_data" @click="openDeleteGroupModal(item, index)" fab dark color="#FF0000" width="15" height="15" elevation="1" class="mr-2 animate-show-card" :class="{ 'ml-4' : item.level === 1, 'ml-8' : item.level === 2, }">
                                                                <v-icon size="16">
                                                                    mdi-minus
                                                                </v-icon>
                                                            </v-btn>
                                                        </span>
                                                    </template>
                                                    <span class="font-theme">Delete {{ convertTooltipHeader(item.level)  }}</span>
                                                </v-tooltip>
                                                <v-text-field v-if="item.level === 0" style="font-weight: 700; color: black;" hide-details outlined height="22" color="black" v-model="item.group_name" @focus="setValueForCheck(index)" class="font-theme input-each-group-dashboard-budget" :rules="[ v => !!v ]" required></v-text-field>
                                                <v-text-field v-else-if="item.level === 1" style="font-weight: 400; color: black;" hide-details outlined height="22" color="black" v-model="item.group_name" @focus="setValueForCheck(index)"  class="font-theme input-each-group-dashboard-budget" :rules="[ v => !!v ]" required></v-text-field>
                                                <v-text-field v-else-if="item.level === 2" style="font-weight: 400; color: black;" hide-details outlined height="22" color="black" :class="{ 'ml-4' : !editButton.delete_data }" @focus="setValueForCheck(index)"  v-model="item.group_name" class="font-theme input-each-group-dashboard-budget" :rules="[ v => !!v ]" required></v-text-field>
                                                <v-text-field v-else-if="item.level === 3" style="font-weight: 400; color: black;" hide-details outlined height="22" color="black" :class="{ 'ml-8' : !editButton.delete_data }" @focus="setValueForCheck(index)"  v-model="item.group_name" class="font-theme input-each-group-dashboard-budget" :rules="[ v => !!v ]" required></v-text-field>
                                                <span v-else-if="item.level === 4" style="font-weight: 400; font-size: 12px; color: black; padding-left: 16px;">{{ item.group_name }}</span>
                                            </v-row>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px 0px 28px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[0].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[0].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[0].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[0].amount" @focus="setValueForCheck(index, 0)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{  'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[1].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[1].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[1].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[1].amount" @focus="setValueForCheck(index, 1)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[2].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[2].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[2].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[2].amount" @focus="setValueForCheck(index, 2)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[3].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[3].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[3].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[3].amount" @focus="setValueForCheck(index, 3)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[4].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[4].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[4].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[4].amount" @focus="setValueForCheck(index, 4)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[5].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[5].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[5].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[5].amount" @focus="setValueForCheck(index, 5)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[6].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[6].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[6].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[6].amount" @focus="setValueForCheck(index, 6)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[7].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[7].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[7].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[7].amount" @focus="setValueForCheck(index, 7)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[8].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[8].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[8].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[8].amount" @focus="setValueForCheck(index, 8)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[9].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[9].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[9].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[9].amount" @focus="setValueForCheck(index, 9)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[10].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[10].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[10].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[10].amount" @focus="setValueForCheck(index, 10)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body" style="padding: 0px 28px 0px 2px;" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color':item.budget[11].edit === true ? '#A7CD6980':'#A9C5C3', 'font-weight': 700 } : { 'background-color':item.budget[11].edit === true ? '#A7CD6980':'#F5F5F5', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.budget[11].amount }}</v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="item.budget[11].amount" @focus="setValueForCheck(index, 11)" @keyup="calculateTotalNumber(item)" required :style="{ 'font-weight': item.level === 0 || item.level === 1 ? 700 : 400 }"></TextFieldEdit>
                                        </td>
                                        <td class="dashboard-budget-table-body px-1 total-budget-dashboard-table-body" :class="{ 'pt-7' : item.level === 0, 'pb-7' : index === budgetDashboardData.group_budget_body_table.length - 1 }">
                                            <v-row class="standard-row d-flex justify-center" style="font-size: 12px;" :style="item.level === 0 ? { 'background-color': '#A9C5C3', 'font-weight': 700 } : { 'background-color': '#CBD48F', 'font-weight': item.level === 1 ? 700 : 400 }">{{ item.sum_amount }}</v-row>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr style="pointer-events: none;">
                                        <td colspan="14" class="px-0">
                                            <v-row class="standard-row no-data-budget-dashboard-table d-flex align-end">
                                                ไม่พบข้อมูล
                                            </v-row>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <AddExcelBudgetingModal />
        <ConfirmDeleteGroupModal />
        <AddGroupDashboardBudget />
    </div>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import ConfirmDeleteGroupModal from '../components/ConfirmDeleteGroupModal.vue'
import AddGroupDashboardBudget from '../components/AddGroupDashboardBudget.vue'
import TextFieldEdit from "../components/module/TextFieldEditBudgetDashboard.vue"
import AddExcelBudgetingModal from '../components/addExcelBudgetingModal.vue'
export default {
    components: {
        TextFieldEdit,
        ConfirmDeleteGroupModal,
        AddGroupDashboardBudget,
        AddExcelBudgetingModal
    },
    props: [
        "budget_type"
    ],
    data: () => ({
        windowSize: { x: 0 },
        editButton: {
            "edit_name"         : false,
            "edit_button"       : false,
            "edit_number"       : false,
            "delete_data"       : false,
            "history_dashboard" : false
        },
        checkPrivilegeButton: false,
        isReady: false,
        newValueChanged: [],
        budgetType: '',
        callApiPending: 0,
        callcheckApiPending: 0,
        callcheckApiPendingPerson: 0,
        selectedBiz: null,
        tempDeleteGroup: [],
        historyBudgetList: [],
        tempIndexEditNumber: [],
        budgetDashboardData: {},
        selectedHistoryBudget: {},
        budgetDashboardCloneData: {},
        selectedGroup: { "_id" : null, "group_name" : 'All'},
        budgetRules: [ v => v !== null && v !== undefined && v !== '' ],
        saveForCheckValue: { name: {}, value: {}, check_edit_event: null },
        year_selected: new Date().getFullYear().toString(),
        year_list: [
            (new Date().getFullYear() - 2).toString(),
            (new Date().getFullYear() - 1).toString(),
            new Date().getFullYear().toString()
        ]
    }),
    beforeDestroy () {
        EventBus.$off('afterAddGroupBudget')
        EventBus.$off('afterConfirmDeleteGroup')
    },
    mounted () {
        this.selectedBiz = this.$store.state.confirmSelectedBiz
        this.onResize()
        this.searchGroupBudget()
        EventBus.$on('afterAddGroupBudget', this.searchGroupBudget)
        EventBus.$on('afterConfirmDeleteGroup', this.confirmDeleteGroup)
        if(this.selectedBiz.tax_id === '0107544000094') this.checkButtonPermission()
        else this.checkButtonPermissionJV()
    },
    watch: {
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        },
        '$route.query'() {
            this.$nextTick(() => {
                this.isReady                  = false
                this.budgetType               = ''
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
                this.selectedGroup = { 
                    "_id" : null,
                    "group_name" : 'All'
                },
                this.editButton = {
                    "edit_name"         : false,
                    "edit_button"       : false,
                    "edit_number"       : false,
                    "delete_data"       : false,
                    "history_dashboard" : false
                },
                this.saveForCheckValue = { 
                    "name"             : {},
                    "value"            : {},
                    "check_edit_event" : null 
                }
                this.searchGroupBudget()
                this.checkPrivilegeButton     = false
                if(this.selectedBiz.tax_id === '0107544000094') this.checkButtonPermission()
                else this.checkButtonPermissionJV()
            })
        }
    },
    methods: {
       
        async checkButtonPermissionJV() {
            try {
                this.callcheckApiPendingPerson++;
                const response = await this.axios.get(`${this.$api_url}/permission_dashboard/api/v1/check_permission_dashboard_JV?tax_id=${this.selectedBiz.tax_id}`);
                const personalIdentity = response.data.data.personalIdentity;
                this.checkPrivilegeButton = personalIdentity;
            } catch (error) {
                console.log('Error fetching button permission:', error);
            } finally {
                this.callcheckApiPendingPerson--;
            }
        },
        async checkButtonPermission() {
            try {
                this.callcheckApiPending++;
                const response = await this.axios.get(`${this.$api_url}/permission_dashboard/api/v1/check_permission_dashboard_inet`);
                const privilege = response.data.data.privilege;
                this.checkPrivilegeButton = privilege;               
            } catch (error) {
                console.log('Error fetching button permission:', error);
            } finally {
                this.callcheckApiPending--;
            }
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        async download_report_history_budget() {
            try {
                this.callApiPending++
                const data = await this.axios.get(`${this.$api_url}report/api/v1/export_reporthistory?budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&tax_id=${this.selectedBiz.tax_id || ''}&history_date_string=${this.selectedHistoryBudget.history_date_string || ''}`, { responseType: "blob" })
                if (data.data) {
                    const link = document.createElement("a")
                    link.href  = window.URL.createObjectURL(new Blob([data.data]))
                    link.setAttribute("download", `history dashboard budget ${this.selectedHistoryBudget.history_date}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success')
                } else {
                    this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
            }      
        },
        async download_report_budget() {
            try {
                this.callApiPending++
                const config = {
                    baseURL: this.$api_url,
                    url: "/report/api/v1/export_report_dashbord_budget",
                    method: "GET",
                    responseType: "blob",
                    params: {
                        tax_id: this.selectedBiz.tax_id || '',
                        budget_type: this.budget_type || '',
                        type: this.budgetType || '',
                        year: this.year_selected
                    }
                }
                const data = await this.axios(config)
                if (data.data) {
                    const link = document.createElement("a")
                    link.href  = window.URL.createObjectURL(new Blob([data.data]))
                    link.setAttribute("download", `Report dashboard budget ${this.budgetType === '' ? 'total' : this.budgetType} ${this.budget_type.toLowerCase()} ${MainFunction.shortDate(new Date())}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success')
                } else {
                    this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
            }      
        },
        convertDataApiToTable(groupBudget, budget_type) {
            let result = []
            function enumerateSubGroup(budget, type, level) {
                for (let index = 0; index < budget.length; index++) {
                    result.push({
                        "_id"                : budget[index]._id,
                        "level"              : (['plan', 'actual'].includes(budget[index].group_name?.toLowerCase()) && !budget_type)? 4 : level,
                        "edit_number_status" : false,
                        "edit_type"          : budget[index].edit_type,
                        "type"               : `${type}_${index}`,
                        "group_name"         : budget[index].group_name,
                        "sum_amount"         : Number(budget[index].sum_amount)? MainFunction.addComma(Number(budget[index].sum_amount)) : budget[index].sum_amount,
                        "budget"             : budget[index].budget?.map(e => { return { "month" : e.month, "amount": Number(e.amount)? MainFunction.addComma(Number(e.amount)) : e.amount ,"edit": e.edit}}) || []
                    })
                    if (budget[index].group_budget && budget[index].group_budget.length > 0) {
                        enumerateSubGroup(budget[index].group_budget, `${type}_${index}`, level + 1)
                    }
                }
            }
            for (let index = 0; index < groupBudget.length; index++) {
                result.push({
                    "_id"                : groupBudget[index]._id,
                    "edit_number_status" : false,
                    "edit_type"          : groupBudget[index].edit_type,
                    "level"              : 0,
                    "type"               : `group${index}`,
                    "group_name"         : groupBudget[index].group_name,
                    "sum_amount"         : Number(groupBudget[index].sum_amount)? MainFunction.addComma(Number(groupBudget[index].sum_amount)) : groupBudget[index].sum_amount,
                    "budget"             : groupBudget[index].budget?.map(e => { return { "month" : e.month, "amount": Number(e.amount)? MainFunction.addComma(Number(e.amount)) : e.amount ,"edit": e.edit}}) || []
                })
                if (groupBudget[index].group_budget && groupBudget[index].group_budget.length > 0) {
                    enumerateSubGroup(groupBudget[index].group_budget, result.at(-1).type, 1)
                }
            }
            return result
        },
        // createGroupBudgetTree(data) {
        //     let result = []
        //     for (let i = 0; i < data.length; i++) {
        //         switch(data[i].type) {
        //             case 'group':
        //                 result.push(data[i])
        //                 break;
        //             case 'sub_group1':
        //                 if (!result[result.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget.push(data[i])
        //                 break;
        //             case 'sub_group2':
        //                 if (!result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.push(data[i])
        //                 break;
        //             case 'sub_group3':
        //                 if (!result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget.push(data[i])
        //                 break;
        //         }
        //     }
        //     return result
        // },
        async searchGroupBudget() {
            this.editButton.edit_name               = false
            this.editButton.edit_button             = false
            this.editButton.edit_number             = false
            this.editButton.delete_data             = false
            this.saveForCheckValue.check_edit_event = null
            this.selectedGroup = { 
                "_id" : null,
                "group_name" : 'All'
            }
            this.tempDeleteGroup = []
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/search_group_budget_v2?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&year=${Number(this.year_selected)}`)
                if (data.status && Object.keys(data.data).length) {
                    this.budgetDashboardData = {
                        ...data.data,
                        "budget_plan"             : MainFunction.addComma(Number(data.data?.budget_plan   || '0')),
                        "budget_actual"           : MainFunction.addComma(Number(data.data?.budget_actual || '0')),
                        "budget_total"            : MainFunction.addComma(Number(data.data?.budget_total  || '0')),
                        "group_budget_body_table" : this.convertDataApiToTable(data.data.group_budget, this.budgetType)
                    }
                    this.budgetDashboardCloneData = structuredClone(this.budgetDashboardData)
                    this.budgetDashboardData.group_budget.unshift({
                        "_id"        : null,
                        "group_name" : 'All'
                    })
                    const newValueChanged = JSON.parse(JSON.stringify(this.budgetDashboardData.group_budget_body_table));
                    this.newValueChanged = newValueChanged
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                }
            } catch (error) {
                console.log(error)
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
            } finally {
                this.callApiPending--
                this.isReady = true
            }
        },
        filterDataByGroup(data) {
            this.callApiPending++
            setTimeout(() => {
                if (!data._id) {
                    this.budgetDashboardData.group_budget_body_table = this.convertDataApiToTable(this.budgetDashboardCloneData.group_budget, this.budgetType)
                } else {
                    this.budgetDashboardData.group_budget_body_table = this.convertDataApiToTable([ data ], this.budgetType)
                }
                this.$nextTick(() => {
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                    this.callApiPending--
                })
            }, 300);
        },
        addFileExcelBudgeting() {
            EventBus.$emit('addFileExcelBudgeting', this.budget_type , this.year_selected)
        },
        saveAllData() {
            this.callApiPending++
            setTimeout(async () => {
                if (!this.$refs.budgetForm.validate()) {
                    this.callApiPending--
                    return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                }
                if (this.saveForCheckValue.check_edit_event === 'number' && this.tempIndexEditNumber.length) {
                    this.closeEventEditNumberAfterHoldButton()
                }
                const tempNameChanged = Object.entries(this.saveForCheckValue.name).reduce((acc, cur) => {
                    const [key, value] = cur
                    const [name, id]   = value.split("_/_/_")
                    const tempDate     = this.budgetDashboardData.group_budget_body_table[key] || null
                    if (name !== tempDate.group_name && id === tempDate._id) {
                        acc.push(this.budgetDashboardData.group_budget_body_table[key]) 
                    }
                    return acc
                }, [])
                let tempValueChanged = []
                Object.entries(this.saveForCheckValue.value).forEach(e => {
                    const [key, value] = e
                    const [x, y]       = key.split("_")
                    const [number, id] = value.split("_/_/_")
                    const tempData     = this.budgetDashboardData.group_budget_body_table[x] || null
                    // if (!tempValueChanged.some(e => e._id === id) && (number !== tempData?.budget[y]?.amount && id === tempData._id)) {
                        tempValueChanged.push(this.budgetDashboardData.group_budget_body_table[x]) 
                    // }
                })
                if (tempValueChanged.length || tempNameChanged.length || this.tempDeleteGroup.length) {
                    if (await this.updateBudgetDashboardAPI(tempNameChanged, tempValueChanged)) {
                        this.editButton = {
                            "edit_name"         : false,
                            "edit_button"       : false,
                            "edit_number"       : false,
                            "delete_data"       : false,
                            "history_dashboard" : false                   
                        }
                        this.searchGroupBudget()
                        this.checkPrivilegeButton = true
                    }
                } else {
                    this.editButton = {
                        "edit_name"         : false,
                        "edit_button"       : false,
                        "edit_number"       : false,
                        "delete_data"       : false,
                        "history_dashboard" : false 
                    }
                   this.checkPrivilegeButton = true
                }
                this.saveForCheckValue = { name : {}, value : {}, check_edit_event: null }
                this.tempDeleteGroup   = []
                this.$nextTick(() => {
                    this.callApiPending--
                })
            }, 500);
        },
        calculateTotalNumber(item) {
                // item.sum_amount = 0
                // for (let i = 0; i < item.budget.length; i++) {
                //     item.sum_amount += (item.budget[i]?.amount === '-' || !item.budget[i]?.amount)? 0 : +item.budget[i].amount?.replace(/,/g, '')
                // }
                item.sum_amount = item.budget.filter(e => e.amount !== '-' && e.amount).reduce((total, next) => total + Number(next.amount.replace(/,/g, '')), 0)
                item.sum_amount = MainFunction.addComma(+(item.sum_amount.toFixed(2)))
                this.$forceUpdate()
        },
        setValueForCheck(x, y) {
            if (y === undefined || y === null) {
                if (this.saveForCheckValue.name.hasOwnProperty(x)) {
                    return
                }
                const tempData = this.budgetDashboardData.group_budget_body_table[x]
                this.saveForCheckValue.name[x] = `${tempData.group_name}_/_/_${tempData._id}`
            } else {
                if (this.saveForCheckValue.value.hasOwnProperty(`${x}_${y}`)) {
                    return
                }
                const tempData = this.budgetDashboardData.group_budget_body_table[x]
                this.saveForCheckValue.value[`${x}_${y}`] = `${tempData.budget[y].amount}_/_/_${tempData._id}`
            }
            this.tempIndexEditNumber = [...new Set(Object.keys(this.saveForCheckValue.value).map(key => parseInt(key.split('_')[0])))]
        },
        convertTooltipHeader(level) {
            let text = null
            switch(level) {
                case 1:
                    text = 'sub group1'
                    break;
                case 2:
                    text = 'sub group2'
                    break;
                case 3:
                    text = 'sub group3'
                    break;
                default:
                    text = 'group'
            }
            return text
        },
        openDeleteGroupModal(item, index) {
            const tempItem = {
                ...item,
                index     : index,
                type_text : this.convertTooltipHeader(item.level)
            }
            EventBus.$emit('openConfirmDeleteGroupModal', tempItem)
        },
        confirmDeleteGroup(item) {
            this.tempDeleteGroup.push(item)
            this.budgetDashboardData.group_budget_body_table = this.budgetDashboardData.group_budget_body_table.filter(e => !e.type.startsWith(item.type))
        },
        async updateBudgetDashboardAPI(nameChanged = [], valueChanged = []) {
            try {
                let tempPromise = []
                if (this.tempDeleteGroup.length) {
                    tempPromise.push({
                        method  : 'POST',
                        baseURL : this.$api_url,
                        url     : `/group_budget/api/v1/delete_group_subgroup`,
                        data    : { "group": this.tempDeleteGroup.map(e => ({ "_id": e._id })) }
                    })
                }
                if (nameChanged.length || valueChanged.length) {
                    if (nameChanged.length) {
                        const tempBodyEditName = {
                            "group"          : nameChanged.map(e => ({
                                "_id"        : e?._id || null,
                                "group_name" : e?.group_name,
                            })).filter(e => e._id && !['plan', 'actual'].includes(e?.group_name?.toLowerCase()))
                        }
                        tempPromise.push({
                            method  : 'POST',
                            baseURL : this.$api_url,
                            url     : `/group_budget/api/v1/edit_group_name`,
                            data    : tempBodyEditName
                        })
                    }
                    if (valueChanged.length) {
                        const tempBodyEditData = {
                            "type"             : this.budgetType,
                            "group" : valueChanged.map(e => {
                                const foundItem = this.newValueChanged.find(item => item._id === e._id);   
                                return {
                                    "_id": e._id,
                                    "budget": e.budget?.map((e1,index) => {
                                        var isPositionEdited = false
                                        var itemAmount = ""
                                        if(foundItem.budget[index].amount === '-'){
                                            itemAmount = "0.00"
                                        }else{
                                            itemAmount = parseFloat(foundItem.budget[index].amount.replace(/,/g, '')).toFixed(2);                                
                                        }
                                        const e1Amount = e1.amount === '-' ? '0.00' : e1.amount; 
                                        const formattedItemAmount = itemAmount
                                        const formattedItemAmountE1 = e1Amount.replace(/,/g, '');
                                        if(formattedItemAmountE1 !== formattedItemAmount){
                                            isPositionEdited = true;
                                        }

                                        return {
                                            ...e1,
                                            amount: e1.amount === '-' ? null : Number(e1.amount?.replace(/,/g, '') || '0'),
                                            edit: isPositionEdited 
                                        };
                                    }),
                                    "total_budget" : Number(e.sum_amount?.replace(/,/g, '') || '0'),
                                }})
                        }
                        tempPromise.push({
                            method  : 'POST',
                            baseURL : this.$api_url,
                            url     : `/group_budget/api/v1/edit_group_month`,
                            data    : tempBodyEditData
                        })
                    }
                }
                const data = await Promise.allSettled(tempPromise.map(e => this.axios(e)))
                if (data.some(e => e.status === 'fulfilled' && e.value.data.status)) {
                    this.alert(`อัปเดตข้อมูลสำเร็จ`, 'Success', 'success')
                    return true
                } else {
                    this.alert(`อัปเดตข้อมูลไม่สำเร็จ`, 'Fail', 'error')
                    return false
                }
            } catch (error) {
                console.log(error)
                this.alert(`อัปเดตข้อมูลไม่สำเร็จ`, 'Fail', 'error')
                return false
            }
        },
        async getListHistoryBudget(trig_state = false) {
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/list_history?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type?.toUpperCase() || ''}&type=${this.budgetType || ''}&year=${Number(this.year_selected)}`)
                if (data.status) {
                    this.selectedHistoryBudget = {}
                    this.historyBudgetList     = []
                    for (let i = 0; i < data.data.length; i++) {
                        const tempData = data.data[i].editor
                        this.historyBudgetList.push({
                            ...data.data[i],
                            history_date   : MainFunction.shortDate(data.data[i].history_date_string || null),
                            edit_full_name : `${tempData.first_name_th || tempData.first_name_eng} ${tempData.last_name_th || tempData.last_name_eng}`
                        })
                    }
                }
            } catch (error) {
                console.log(error)
                this.selectedHistoryBudget = {}
                this.historyBudgetList     = []
            } finally {
                this.callApiPending--
                if (trig_state) {
                    this.editButton.history_dashboard = !this.editButton.history_dashboard
                }
            }
        },
        async searchHistoryBudget(editors, index) {
            if (index === this.selectedHistoryBudget?.index) {
                return
            }
            this.selectedHistoryBudget = { ...editors, index}
            this.$forceUpdate()
            this.selectedGroup = { 
                "_id" : null,
                "group_name" : 'All'
            }
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/history_group_budget?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&history_date_string=${editors.history_date_string || ''}&year=${Number(this.year_selected)}`)
                if (data.status && Object.keys(data.data).length) {
                    this.budgetDashboardData = {
                        ...data.data,
                        "budget_plan"             : MainFunction.addComma(Number(data.data?.budget_plan   || '0')),
                        "budget_actual"           : MainFunction.addComma(Number(data.data?.budget_actual || '0')),
                        "budget_total"            : MainFunction.addComma(Number(data.data?.budget_total  || '0')),
                        "group_budget_body_table" : this.convertDataApiToTable(data.data.group_budget, this.budgetType)
                    }
                    this.budgetDashboardCloneData = structuredClone(this.budgetDashboardData)
                    this.budgetDashboardData.group_budget.unshift({
                        "_id"        : null,
                        "group_name" : 'All'
                    })
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                }
            } catch (error) {
                console.log(error)
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
            } finally {
                this.callApiPending--
            }
        },
        editNameToggle() {
            if (!this.$refs.budgetForm.validate()) {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
            this.callApiPending++
            setTimeout(() => {
                this.editButton.edit_name = !this.editButton.edit_name
                this.$nextTick(() => {
                    this.saveForCheckValue.check_edit_event = 'name'
                    this.callApiPending--
                })
            }, 500);
        },
        editNumberToggle() {
            if (!this.$refs.budgetForm.validate()) {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
            if (this.saveForCheckValue.check_edit_event === 'number' && this.tempIndexEditNumber.length) {
                this.closeEventEditNumberAfterHoldButton()
            } else {
                this.tempIndexEditNumber = []
            }
            this.editButton.edit_number = !this.editButton.edit_number
            this.saveForCheckValue.check_edit_event = 'number'
        },
        closeEventEditNumberAfterHoldButton() {
            this.tempIndexEditNumber = [...new Set(this.tempIndexEditNumber)]
            if (this.tempIndexEditNumber.length) {
                for (let i = 0; i < this.tempIndexEditNumber.length; i++) {
                    this.budgetDashboardData.group_budget_body_table[this.tempIndexEditNumber[i]].edit_number_status = false
                }
            }
            this.tempIndexEditNumber = []
        },
        eachEditNumberToggle(item) {
            if (item.edit_number_status) {
                for (let i = 0; i < item.budget.length; i++) {
                    if (!item.budget[i].amount) {
                        this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        return
                    }
                }
            }
            item.edit_number_status = !item.edit_number_status
        },
        editDeleteToggle() {
            this.callApiPending++
            setTimeout(() => {
                this.editButton.delete_data = !this.editButton.delete_data
                this.$nextTick(() => {
                    this.saveForCheckValue.check_edit_event = 'delete'
                    this.callApiPending--
                })
            }, 500);
        },
        openAddGroupModal() {
            const temp_data = {
                tax_id      : this.selectedBiz.tax_id,
                type        : this.budgetType,
                budget_type : this.budget_type,
                budget      : this.budgetDashboardCloneData,
                year        : Number(this.year_selected)
            }
            this.saveForCheckValue.check_edit_event = 'add_group'
            EventBus.$emit('openAddGroupBudgetDashboardModal', temp_data)
        },
        changeTypeEvent() {
            if (this.editButton.history_dashboard) {
                this.getListHistoryBudget()
                this.selectedHistoryBudget = {}
            }
            this.searchGroupBudget()
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    },
}
</script>

<style>
    .background-card-budgeting-permission {
        margin: 60px 3.26% 56px 3.26% !important;
        background-color: white;
        border-radius: 23px !important;
    }

    .button-header-budget-permission {
        border-radius: 10px;
        color: white !important;
        font-size: 16px;
        font-weight: 700;
        box-shadow: none;
    }

    .button-header-budget-permission:not(.v-btn--round).v-size--default {
        min-width: auto;
    }

    .topics-budget-box-header {
        font-weight: 700;
        font-size: 15px;
    }

    .topics-budget-box-value {
        font-size: 26px;
        border-radius: 10px;
        border: 1px solid black;
    }

    .topics-budget-box-value .v-input__control .v-input__slot .v-text-field__slot input {
        max-height: 62px;
    }

    .button-group-budgeting-permission {
        font-weight: 700 !important;
        font-size: 15px !important;
        color: black;
        letter-spacing: 1px;
    }

    .active-button-group-budgeting-permission {
        background-color: #414040;
        color: white !important;
    }

    .data-table-dashboard-budget {
        width: 100%;
        border-right: none !important;
    }

    .group-name-dashboard-budget-table-header {
        position: sticky;
        left: 0;
        background-color: #333333 !important;
        color: white !important;
        height: 66px !important;
        font-size: 15px !important;
        z-index: 3 !important;
        padding-right: 8% !important;
    }

    .total-dashboard-budget-table-header {
        position: sticky;
        right: 0;
        background-color: #333333 !important;
        color: white !important;
        height: 66px !important;
        font-size: 15px !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar {
        height: 6px;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        background: #F5F5F5;
        border-radius: 10px;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-track {
        background: transparent;
    }

    .data-table-dashboard-budget.v-data-table > .v-data-table__wrapper > table {
        width: 100vw !important;
    }

    .data-table-dashboard-budget {
        border: 1px solid #E0E0E0;
        border-radius: 4px !important;
    }

    .group-name-dashboard-table-body {
        border-bottom: none !important;
        background-color: white; 
        transform: scale(1);
        position: sticky;
        left: 0;
        box-shadow: 10px 0px 10px rgba(0, 0, 0, 0.04);
        z-index: 1;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table > tbody > tr > td {
        height: 25px !important;
    }

    .total-budget-dashboard-table-body {
        background-color: white;
        border-bottom: none !important;
        transform: scale(1);
        position: sticky;
        right: 0;
        box-shadow: -10px 0px 10px rgba(0, 0, 0, 0.04);
    }

    .dashboard-budget-table-body {
        border-bottom: none !important;
        background-color: white !important;
    }

    .dashboard-budget-table-header {
        font-size: 15px !important;
        font-weight: 700;
        color: white !important;
        border-bottom: none !important;
        height: 66px !important;
        text-align: center !important;
        background-color: #333333 !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper {
        height: calc(100vh - 174px);
        overflow: auto;
        /* scroll-behavior: smooth; */
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-track {
        background-color: #f1f1f1 !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        background-color: #888;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
        background-color: #333333;
    }

    .budget-dashboard-dropdown-select-group.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto !important;
    }

    .budget-dashboard-dropdown-select-group .v-input__control .v-input__slot {
        padding-right: 5px !important;
    }
    
    .budget-dashboard-dropdown-select-group {
        border-radius: 10px;
        font-size: 15px;
        /* border-color: #333333; */
    }

    .budget-dashboard-dropdown-select-year.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto !important;
    }

    .budget-dashboard-dropdown-select-year .v-input__control .v-input__slot {
        padding-right: 5px !important;
    }
    
    .budget-dashboard-dropdown-select-year {
        border-radius: 10px;
        font-size: 15px;
    }

    .no-data-budget-dashboard-table {
        width: max-content;
        height: 100px;
        position: sticky;
        font-size: 25px;
        font-weight: 700;
        left: 45vw;
        color: #D3D3D3;
    }

    .input-each-group-dashboard-budget > .v-input__control > .v-input__slot {
        min-height: auto;
    }

    .input-each-group-dashboard-budget > .v-input__control > .v-input__slot {
        padding: 0 7px !important;
    }

    .input-each-group-dashboard-budget {
        font-size: 12px;
    }

    .centered-input-dashboard-budget .v-input__control .v-input__slot .v-text-field__slot input {
        text-align: center
    }

    .table-budget-dashboard-card {
        background-color: #FFFFFF;
        border-radius: 23px;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
    }

    .budget-dashboard-card1 {
        margin: 60px 0 56px 0 !important;
        padding: 0 3.26% 0 0%;
    }

    .budget-dashboard-card {
        margin: 60px 0 56px 0 !important;
        padding: 0 3.26% 0 3.26%;
    }

    .animate-history-dashboard-budget-card {
        opacity: 0;
        transform: translateX(-100%) rotateY(-90deg);
        animation: history-card-animation 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) forwards;
    }

    .history-dashboard-budget-card {
        width: auto !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        border-radius: 0px 23px 23px 0px;
    }

    .header-history-budget-dashboard {
        line-height: 20px;
        font-weight: 400;
        font-size: 12px;
    }

    .budget-history-table-card {
        height: 100%;
        width: auto;
        background-color: white;
        border-radius: 0px 23px 23px 0px !important;
    }

    .scrollbar-history-budget-dashboard-tab {
        overflow-y: auto;
        max-height: calc(100vh - 119px);
        scroll-behavior: smooth;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb {
        background-color: #F0F0F0;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb:hover {
        background-color: #D9D9D9;
    }

    .active-selected-history-budget-dashboard,.selected-history-budget-dashboard:hover {
        color: black !important;
        font-weight: 700;
        cursor: pointer;
    }

    .active-selected-event-button-mobile {
        margin: 0 8px;
        color: black !important;
        background-color: #f1f1f1 !important;
    }

    @keyframes history-card-animation {
        0% {
            opacity: 0;
            transform: translateX(-100%) rotateY(-90deg);
        }
        100% {
            opacity: 1;
            transform: translateX(0%) rotateY(0deg);
        }
    }

    @media only screen and (max-width: 1000px) {

        .group-name-dashboard-budget-table-header {
            position: sticky !important;
            left: auto !important;
        }

        .total-dashboard-budget-table-header {
            position: sticky !important;
            right: auto !important;
        }

        .group-name-dashboard-table-body {
            transform: none !important;
            position: static !important;
        }

        .total-budget-dashboard-table-body {
            transform: sticky !important;
            position: static !important;
        }
    }

    @media only screen and (max-width: 960px) {
        .budget-dashboard-card1 {
            margin: 60px 0 56px 0 !important;
            padding: 0 3.26% 0 3.26%;
        }

        .budget-history-table-card {
            height: auto !important;
            border-radius: 23px !important;
        }

        .scrollbar-history-budget-dashboard-tab {
            max-height: calc(100vh - 466px);
        }
    }

    @media only screen and (min-width: 960px) and (max-width: 1263px) {
        .scrollbar-history-budget-dashboard-tab {
            max-height: calc(100vh - 21px)
        }
    }
</style>
